import { useState, useEffect } from 'react'
import { friendsService } from '../services/friendsService'

export const useFriendsData = () => {
  const [friendRequests, setFriendRequests] = useState([])
  const [sentRequests, setSentRequests] = useState([])
  const [friends, setFriends] = useState([])

  const loadFriendRequests = async () => {
    try {
      const data = await friendsService.getPendingRequests()
      setFriendRequests(data.requests || [])
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error loading friend requests:', error)
    }
  }

  const loadSentRequests = async () => {
    try {
      const data = await friendsService.getSentRequests()
      setSentRequests(data.requests || [])
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error loading sent requests:', error)
    }
  }

  const loadFriends = async () => {
    try {
      const data = await friendsService.getFriends()
      setFriends(data.friends || [])
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error loading friends:', error)
    }
  }

  const refreshData = () => {
    loadFriendRequests()
    loadSentRequests()
    loadFriends()
  }

  useEffect(() => {
    refreshData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    friendRequests,
    sentRequests,
    friends,
    loadFriendRequests,
    loadSentRequests,
    loadFriends,
    refreshData
  }
}